import { StaticQuery, graphql, Link } from 'gatsby'
import React from 'react'
import { GatsbyImage } from "gatsby-plugin-image"
import twitterIcon from '../images/twitter-square-brands.svg'
import linkedinIcon from '../images/linkedin-brands.svg'
import external from '../images/external_turquoise.png'
// import githubIcon from '../images/github-brands.svg'
import './styles/featuredSpeakers.scss';
// import { AnchorLink } from "gatsby-plugin-anchor-links";


const FeaturedSpeakers = () => {
    return (
        <StaticQuery 
            query={graphql`
                query FeaturedSpeakersQuery {
                    allFeaturedSpeakersJson {
                        nodes {
                            name
                            company
                            position
                            headshot {
                                childImageSharp {
                                    gatsbyImageData(layout:CONSTRAINED)
                                }
                            }
                            twitter
                            linkedin
                            blog
                        }
                    }
                }  
            `}
            render={data => (
                <section className="featuredSpeakers" id="featured-speakers">
                    <div className="container">
                        <h2>Featured Speakers</h2>

                    
                        <div className="speakers">
                            {data.allFeaturedSpeakersJson.nodes.map(m => (
                                <article className="speaker" key={m.name.toString()}>
                                    <div className="img-wrapper">
                                        <GatsbyImage alt={m.name} image={m.headshot.childImageSharp.gatsbyImageData} /></div>
                                    <div className="txt-wrapper">
                                        <span>{m.name}</span>
                                        <div className="company">{m.company}{m.position && ","}</div>
                                        <div className="company">{m.position}</div>
                                        {m.blog && 
                                            <div className="company blog"><a href={m.blog} target="_blank" rel="noreferrer" className="turquoise external">Personal blog</a></div>
                                        }
                                        <ul className="social">

                                            {m.twitter && 
                                            <li><a href={`https://twitter.com/${m.twitter}`} target="_blank" rel="noreferrer"><img alt="Twitter icon" src={twitterIcon} height="16" width="20" /></a></li>
                                            }

                                            {m.linkedin && 
                                            <li><a href={`https://www.linkedin.com/in/${m.linkedin}/`} target="_blank" rel="noreferrer"><img alt="Linkedin icon" src={linkedinIcon} height="20" width="20" /></a></li>
                                            }
                                        </ul>
                                    </div>
                                </article>
                            ))}
                        </div>
                    </div>
                </section>
            )}
        
        />
    )
}


export default FeaturedSpeakers